import {
  CreateChainProdOrderInput,
  ProdOrderSequenceDTO,
  ProdOrderSequenceReturnDTO,
} from '@app/core/models/prod-order';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environment/environment';
import { map } from 'rxjs/operators';
import { _ } from '@ngx-translate/core';

_('Operative.ProdOrderSchedulerDateOverlappingError');

@Injectable({
  providedIn: 'root',
})
export class ProdOrderSequenceService {
  constructor(private readonly http: HttpClient) {}

  getProdOrderSequence(sequenceId: string): Observable<ProdOrderSequenceReturnDTO> {
    return this.http.get<ProdOrderSequenceReturnDTO>(
      `${environment.apiUrl}operative/prod-order-sequence/${sequenceId}`
    );
  }

  getProdOrderSequenceFromDemand(demandId: number): Observable<ProdOrderSequenceReturnDTO> {
    return this.http
      .get<ProdOrderSequenceReturnDTO>(
        `${environment.apiUrl}operative/prod-order-sequence/demand/${demandId}`
      )
      .pipe(
        map((ret) => {
          for (const s of ret.prodOrderSequence) {
            s.poStartDate = new Date(s.poStartDate);
            s.poEndDate = new Date(s.poEndDate);
          }
          return ret;
        })
      );
  }

  createPOChain(criteria: CreateChainProdOrderInput): Observable<boolean> {
    return this.http.post<boolean>(`${environment.apiUrl}operative/prod-order-chain`, criteria);
  }
}
